import React, { useState } from 'react';
import styled from 'styled-components'
import WidgetsIcon from '@mui/icons-material/Widgets';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';


const Header = () => {

const [displayMenu, setDisplayMenu] = useState(false)


const handleClick = (e) => {
    e.preventDefault();
    setDisplayMenu(!displayMenu)
}
    return (
        <>
        <NavBar>
            <span>
                { (localStorage.getItem("token") === "2y1bAAVUSHabbElp2QPFW0UgJls1" || localStorage.getItem("token") === "AsjHNfBsTvYIgJ3PQw8umrBfVdk1") && 
                <a href="/admin"><SettingsIcon/></a>
                }
    
            </span>
        <Link className="homeLink" to='/'>            
        L'ESSENTIEL
        </Link>
       
            <span onClick={handleClick}>
             <WidgetsIcon />
           </span>
           
        </NavBar>

        {displayMenu && (

            <>
        <MenuDisplay>

            <span onClick={handleClick}><CloseIcon/></span>
            

            <ul>
                <Link className='link' to="/" >
                    <li>Accueil</li>
                </Link>
                <Link className='link' to="/carte" >
                    <li>Carte</li>
                </Link>
                 <Link className='link' to="/" >
                    <li>Qui sommes nous?</li>
                </Link>                
                 <Link className='link' to="/map" >
                    <li>Où nous trouver?</li>
                </Link>
            </ul>

        </MenuDisplay>
        </>
        )}

        </>
    );
};

const MenuDisplay = styled.div`
backdrop-filter: blur(2px);
width: 100vw;
height: 100vh;
background-color: rgb(0,0,0,0.8);
display:flex;
flex-direction: column;
z-index: 6;
position: absolute;
top:0;


align-items;center;
color: #a1df98;

span{
    position:absolute;
    top: 0;
    right:0;
    transform: scale(1.5);

    margin: 15px;
    padding: 15px;
    
    width: 38px;
    height: 38px;
    display:flex;
    justify-content:center;
    align-items:center;
    cursor: pointer;
}



ul{
    
    list-style:none;
    text-align:center;
    margin-top: 30px;
    text-decoration: none;

    .link{
        text-decoration: none;
    }

    li{
    text-decoration: none;
    color: #a1df98;
    font-family: 'Lobster';
    font-size: 40px;
    margin-top: 30px;
    }

}


`

const NavBar = styled.nav`
width: 100vw;
height: 60px;
background: linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(258,170,20,0) 100%);
position:fixed;
top:0;
left:0;
z-index:5;
background: url('/images/photoessentiel/header.jpg');
background-size:cover;
background-repeat:no-repeat;
box-shadow: inset rgb(0 0 0 / 73%) 0px -26px 30px -10px,
inset rgb(0 0 0 / 69%) 0px -16px 10px -10px,
 rgb(0 0 0 / 73%) 0px 26px 30px -10px,
 rgb(0 0 0 / 69%) 0px 16px 10px -10px;


display:flex;
justify-content: space-between;
padding-left: 10px;
padding-right: 30px;
align-items: center;
color: #f9f9f9;
overflow:hidden;

span{
    cursor:pointer;
    text-decoration: none;
    color: #g4g4g4;
    transform: scale(1.9);    
    opacity: 1;
    z-index: 999;
    text-shadow: rgb(0 0 0 / 76%) 0px 10px 10px -10px,
    rgb(0 0 0 / 69%) 0px 5px 5px -5px;
    display:flex;
    justify-content:center;
    align-items:center;

    a{
        text-decoration:none;
        color:#fff;
        padding:3px 0px 0px 10px;

    }

    
    
}

.homeLink{
    text-decoration:none;
    color: #fff;
    font-size: 32px;
    position:relative;
    text-shadow: #ccff15 0px 0px 5px , #ccff15 0px 0px  20px, #ccff15 0px 0px 40px;
    object-fit: cover;
    font-weight: 600;
    text-align:center;


}
.homeLink img{

    inset:0;
    
    width: 130px;
    filter: invert(1) grayscale(1);
    
    
}





`


export default Header;